import { Button } from 'primereact/button';
import { useLanguage } from '../../contexts/LanguageContext';

const NewButton = ({ onClick, label }) => {
    const { th } = useLanguage();
    return <Button label={label ?? th('common.new')} icon="pi pi-plus" onClick={onClick} style={{ color: '#fff', backgroundColor: '#0B3187', borderColor: '#0B3187' }} />;
};

export default NewButton;
